import { render } from "./PaperClip.vue?vue&type=template&id=fcedf044"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PaperClip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fcedf044"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fcedf044', __exports__)) {
    api.reload('fcedf044', __exports__)
  }
  
  module.hot.accept("./PaperClip.vue?vue&type=template&id=fcedf044", () => {
    api.rerender('fcedf044', render)
  })

}


export default __exports__